import { audiencerateApi } from '../../audiencerate';
import { AmazonS3FilePreviewRequest, AmazonS3FilePreviewResponse, SFTPFilePreviewRequest, SFTPFilePreviewResponse } from './types';

export const getS3FilePreviewKey = 'get-AmazonS3-file-preview';
export const getSFTPFilePreviewKey = 'get-SFTP-file-preview';

export const filesApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    getS3FilePreview: build.mutation<AmazonS3FilePreviewResponse, AmazonS3FilePreviewRequest>({
      query: (body) => ({
        url: `/v1/upload/s3/preview`,
        method: 'POST',
        body,
      }),
    }),
    getSFTPFilePreview: build.mutation<SFTPFilePreviewResponse, SFTPFilePreviewRequest>({
      query: (body) => ({
        url: `/v1/upload/sftp/preview`,
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetS3FilePreviewMutation, useGetSFTPFilePreviewMutation } = filesApi;
